export default {
  "bonusApproval.title": "优惠人工派发",
  "bonusApproval.copySuccess": "复制成功！",

  "bonusApproval.search.createTime": "创建时间",
  "bonusApproval.search.rewardType": "奖励类型",
  "bonusApproval.search.status": "状态",
  "bonusApproval.search.bonusAmount": "金额",
  "bonusApproval.search.gem": "宝石",
  "bonusApproval.search.BonusWager": "流水",

  "bonusApproval.column.index": "#序号",
  "bonusApproval.column.applyId": "活动奖励ID",
  "bonusApproval.column.userno": "会员编号",
  "bonusApproval.column.email": "邮箱",
  "bonusApproval.column.rewardType": "奖励类型",
  "bonusApproval.column.amount": "金额",
  "bonusApproval.column.status": "状态",
  "bonusApproval.column.remark": "备注",
  "bonusApproval.column.createTime": "创建时间",
  "bonusApproval.column.action": "操作",

  "bonusApproval.action.pass": "通过",
  "bonusApproval.action.reject": "驳回",

  "bonusApproval.confirm.title": "{optWords} 审核",
  "bonusApproval.confirm.content": "确认要{optWords}以下领取申请吗？",
  "bonusApproval.confirm.ok": "确认",
  "bonusApproval.confirm.cancel": "取消",
  "bonusApproval.confirm.selectedIds": "选中的活动奖励ID：{ids}",

  "bonusApproval.remark.placeholder": "请输入备注（可选）",
};
